import styled from 'styled-components'
import { DownloadLink } from 'ui/components/DownloadLink'

export const Company = styled.div`
  margin-bottom: 30px;
`

export const CompanyName = styled.b`
  display: block;
  margin-bottom: 10px;
`

export const DownloadLinkBtn = styled(DownloadLink)`
  margin-top: 20px;
`
